import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetMarkAnimationSettingParams {
  user: string;
}

export interface IGetMarkAnimationSettingResult extends IResult {
  enabled: boolean;
}
export class GetMarkAnimationSettingRequest extends Request<IGetMarkAnimationSettingParams, IResult> {
  constructor(params: IGetMarkAnimationSettingParams) {
    super('getMarkAnimationEnabledSetting', params);
  }
}
